export var SearchModuleActionType;
(function (SearchModuleActionType) {
    SearchModuleActionType["changePriceFormat"] = "changePriceFormat";
    SearchModuleActionType["changeValue"] = "changeValue";
    SearchModuleActionType["changeOpen"] = "changeOpen";
    SearchModuleActionType["changePopularQueries"] = "changePopularQueries";
    SearchModuleActionType["changePreviousQueries"] = "changePreviousQueries";
    SearchModuleActionType["changeEntries"] = "changeEntries";
    SearchModuleActionType["changeCategories"] = "changeCategories";
    SearchModuleActionType["changeLoading"] = "changeLoading";
    SearchModuleActionType["changeSelectedSelections"] = "changeSelectedSelections";
    SearchModuleActionType["changeSports"] = "changeSports";
    SearchModuleActionType["changeSelectedSport"] = "changeSelectedSport";
    SearchModuleActionType["changeQueryIDs"] = "changeQueryIDs";
})(SearchModuleActionType || (SearchModuleActionType = {}));
function createReducers(actions) {
    return actions;
}
export const reducers = createReducers({
    [SearchModuleActionType.changePriceFormat]: (state, priceFormat) => {
        return Object.assign(Object.assign({}, state), { priceFormat });
    },
    [SearchModuleActionType.changeValue]: (state, value) => {
        return Object.assign(Object.assign({}, state), { value });
    },
    [SearchModuleActionType.changeOpen]: (state, open) => {
        return Object.assign(Object.assign({}, state), { open });
    },
    [SearchModuleActionType.changePopularQueries]: (state, popularQueries) => {
        return Object.assign(Object.assign({}, state), { popularQueries: popularQueries.slice().sort((a, b) => b.order - a.order) });
    },
    [SearchModuleActionType.changePreviousQueries]: (state, previousQueries) => {
        return Object.assign(Object.assign({}, state), { previousQueries: previousQueries.slice() });
    },
    [SearchModuleActionType.changeEntries]: (state, data) => {
        return Object.assign(Object.assign({}, state), { entries: data.entries.slice(), entriesTimestamp: Date.now(), searched: Boolean(data.searched || data.entries.length > 0) });
    },
    [SearchModuleActionType.changeCategories]: (state, categories) => {
        return Object.assign(Object.assign({}, state), { categories: Object.assign({}, categories) });
    },
    [SearchModuleActionType.changeLoading]: (state, loading) => {
        return Object.assign(Object.assign({}, state), { loading });
    },
    [SearchModuleActionType.changeSelectedSelections]: (state, selections) => {
        return Object.assign(Object.assign({}, state), { selectedSelections: selections });
    },
    [SearchModuleActionType.changeSports]: (state, sports) => {
        const selectedSport = sports.indexOf(state.selectedSport) === -1 ? null : state.selectedSport;
        return Object.assign(Object.assign({}, state), { sports, selectedSport });
    },
    [SearchModuleActionType.changeSelectedSport]: (state, sport) => {
        return Object.assign(Object.assign({}, state), { selectedSport: sport });
    },
    [SearchModuleActionType.changeQueryIDs]: (state, queryIDs) => {
        return Object.assign(Object.assign({}, state), { queryIDs });
    },
});
//# sourceMappingURL=reducers.js.map